import React from 'react';
import { AlertTriangle, Info, TrendingDown, Building2, AlertCircle, ListChecks } from 'lucide-react';

const DataCoverageWarning = ({ warningData, distressedWarning, arvDataSource, lang = 'en' }) => {
  // V5.2: Show warning for listing-only data
  const isListingOnly = arvDataSource === 'listing';
  const isMixed = arvDataSource === 'mixed';
  
  // V4.5: Simplified warning - don't expose internal model limitations
  // Only show a single professional message about limited comps
  if (!warningData?.has_warning && !distressedWarning?.triggered && !isListingOnly) {
    return null;
  }

  return (
    <div className="space-y-3 mb-4">
      {/* V5.2: Listing-only data warning */}
      {isListingOnly && (
        <div 
          className="rounded-xl border-2 p-4 bg-blue-50 border-blue-200"
          data-testid="listing-only-warning"
        >
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-blue-100">
              <ListChecks className="w-5 h-5 text-blue-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-blue-800">
                {lang === 'en' ? 'Based on Listing Data' : 'Basado en Datos de Listados'}
              </h3>
              <p className="text-sm mt-1 text-blue-700">
                {lang === 'en' 
                  ? 'No recent sold comparables available. This estimate uses active/inactive listings. Add sold comps manually for improved accuracy.'
                  : 'No hay comparables vendidos recientes disponibles. Esta estimación utiliza listados activos/inactivos. Agregue comparables vendidos manualmente para mayor precisión.'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Simplified Data Coverage Warning - V4.5 */}
      {(warningData?.has_warning || distressedWarning?.triggered) && (
        <div 
          className="rounded-xl border-2 p-4 bg-amber-50 border-amber-200"
          data-testid="data-coverage-warning"
        >
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-amber-100">
              <AlertTriangle className="w-5 h-5 text-amber-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-amber-800">
                {lang === 'en' ? 'Limited Comparable Coverage' : 'Cobertura de Comparables Limitada'}
              </h3>
              <p className="text-sm mt-1 text-amber-700">
                {lang === 'en' 
                  ? 'The estimated value is based on the best available data and may improve when adding manual comparables.'
                  : 'El valor estimado se basa en los mejores datos disponibles y puede mejorar al agregar comparables manuales.'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataCoverageWarning;
